import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import usePlayerManifest from "../hooks/usePlayerManifest";

export default function PlayerForgotPassword() {
  usePlayerManifest();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async () => {
    if (!email) return setError("Please enter your email address");
    setLoading(true); setError("");
    try {
      const res = await fetch("/api/player/forgot-password", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) return setError(data.error || "Failed to send reset email");
      setSent(true);
    } catch(e) { setError("Network error"); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f0fdf4", display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}>
      <div style={{ background: "white", padding: "32px", borderRadius: "16px", boxShadow: "0 4px 24px rgba(0,0,0,0.10)", width: "100%", maxWidth: "420px" }}>
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <div style={{ width: "64px", height: "64px", background: "#14532d", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px", fontSize: "28px" }}>⛳</div>
          <h1 style={{ margin: 0, fontSize: "22px", fontWeight: "800", color: "#14532d" }}>Golf Society Manager</h1>
          <p style={{ margin: "6px 0 0", fontSize: "14px", color: "#6b7280" }}>Player — Reset Password</p>
        </div>

        {sent ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "40px", marginBottom: "16px" }}>📧</div>
            <div style={{ fontWeight: "700", color: "#166534", marginBottom: "8px" }}>Reset email sent!</div>
            <p style={{ fontSize: "13px", color: "#6b7280", marginBottom: "20px" }}>Check your inbox for a reset link. It expires in 1 hour.</p>
            <button onClick={() => navigate("/login")}
              style={{ background: "#166534", color: "white", border: "none", borderRadius: "8px", padding: "11px 24px", fontSize: "14px", fontWeight: "700", cursor: "pointer" }}>
              Back to Login
            </button>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {error && <div style={{ background: "#fee2e2", color: "#b91c1c", padding: "10px 14px", borderRadius: "8px", fontSize: "13px" }}>{error}</div>}
            <div>
              <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>Email Address</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && submit()}
                placeholder="your@email.com"
                style={{ width: "100%", border: "1.5px solid #d1d5db", borderRadius: "8px", padding: "11px 14px", fontSize: "15px", boxSizing: "border-box" }} />
            </div>
            <button onClick={submit} disabled={loading}
              style={{ width: "100%", background: loading ? "#86efac" : "#166534", color: "white", fontWeight: "700", fontSize: "16px", padding: "13px", borderRadius: "8px", border: "none", cursor: loading ? "not-allowed" : "pointer" }}>
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
            <button onClick={() => navigate("/login")}
              style={{ background: "none", border: "none", fontSize: "14px", color: "#166534", fontWeight: "600", cursor: "pointer" }}>
              ← Back to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
